// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P5s8aye4J7AkWiJKpV84{justify-content:space-between;display:flex}.ScXDjyMEouUDHIjuK1cH{min-height:32px;color:var(--content-primary-tertiary);flex:0 0 125px}.M2MaPAbwAcYnXIWCOthv{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `P5s8aye4J7AkWiJKpV84`,
	"label": `ScXDjyMEouUDHIjuK1cH`,
	"dropdown": `M2MaPAbwAcYnXIWCOthv`
};
export default ___CSS_LOADER_EXPORT___;
